<template>
  <div>
    <div @click="showBreakdown()">
      <slot></slot>
    </div>

    <HeadlessTransitionRoot as="template" :show="open">
      <HeadlessDialog as="div" class="relative z-50" @close="open = false">
        <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
          leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </HeadlessTransitionChild>

        <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-4">
            <HeadlessTransitionChild as="template" enter="ease-out duration-300"
              enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
              leave-from="opacity-100 translate-y-0 sm:scale-100"
              leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <HeadlessDialogPanel
                class="relative transform overflow-hidden rounded-lg bg-woodsmoke-850 text-left shadow-xl transition-all sm:my-8 sm:w-full w-full sm:max-w-screen-xl">

                <nav class="p-2 px-4 mb-4 w-full flex justify-between items-center bg-white/5">
                  <p>Breakdown</p>

                  <button
                    class="btn btn-sm btn-square bg-white/10 border-none flex justify-center items-center cursor-pointer"
                    @click="open = false">
                    <Icon name="ph:x" class="text-white" />
                  </button>
                </nav>

                <nav class="w-full flex justify-between items-center px-4 pb-4 sm:border-b sm:border-b-white/10">
                  <div>
                    <p class="text-sm text-turquoise-500">total to claim</p>
                    <p class="text-xl text-white">{{ vesting?.amount_eth }} USDT</p>
                  </div>
                  <button @click="claim(vesting)" :disabled="!vesting" v-if="!vesting?.transaction_hash"
                    class="btn bg-turquoise-500 text-turquoise-1000 min-h-0 h-auto py-3 hover:text-white hover:bg-white/10">Claim</button>
                </nav>


                <div class="w-full sm:grid sm:grid-cols-6">

                  <div class="px-4 sm:p-0 sm:border-r sm:border-white/10 sm:col-span-2">

                    <p class="p-0 sm:p-4 text-sm text-woodsmoke-300 col-span-full">Tap on list to view details</p>

                    <div class="w-full sm:bg-transparent bg-white/5 rounded-md my-4 max-h-32 overflow-y-auto text-sm">
                      <div class="w-full p-2 px-4 grid grid-cols-6 justify-center items-center text-center">
                        <p class="text-xs tracking-widest text-turquoise-500 uppercase">ID</p>
                        <p class="text-xs tracking-widest text-turquoise-500 uppercase">type</p>
                        <p class="col-span-2 text-xs tracking-widest text-turquoise-500 uppercase">price</p>
                        <p class="col-span-2 text-xs tracking-widest text-turquoise-500 uppercase">claimable</p>
                      </div>
                      <div @click="splideTo(index)" v-for="(_entry, index) in listings"
                        class="w-full grid grid-cols-6 justify-center items-center p-2 px-4 border-b border-b-white/5 cursor-pointer hover:bg-white/10 text-center"
                        :class="[activeSlide == index ? 'text-white font-bold' : '']">
                        <div>
                          <p class="">{{ _entry.id }}</p>
                        </div>
                        <div>
                          <p class="">{{ _entry.action }}</p>
                        </div>
                        <div class="col-span-2">
                          <p class="">{{ _entry.price }}</p>
                        </div>
                        <div class="col-span-2">
                          <p class="">
                            <span v-if="_entry.action == 'buy'">{{ _entry.claimable }}</span>
                            <span v-if="_entry.action == 'sell'">{{ _entry.claimable }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w-full h-full sm:col-span-4 sm:pt-4">
                    <div class="w-full grid grid-cols-4 pl-4">
                      <div class="col-span-3">
                        <p class="text-turquoise-500">Details</p>
                        <p class="text-sm text-woodsmoke-50">Drag Left & Right</p>
                        <p class="text-sm text-woodsmoke-50">All stated amount are in USDT</p>
                      </div>

                      <div class="w-full flex justify-end space-x-4 items-center px-4">
                        <button @click="prevSlide()"
                          class="btn btn-circle min-h-0 w-8 h-8 rounded-full bg-turquoise-500/20 text-turquoise-500 flex justify-center items-center cursor-pointer">
                          <Icon name="ph:caret-left-bold"></Icon>
                        </button>

                        <button @click="nextSlide()"
                          class="btn btn-circle min-h-0 w-8 h-8 rounded-full bg-turquoise-500/20 text-turquoise-500 flex justify-center items-center cursor-pointer">
                          <Icon name="ph:caret-right-bold"></Icon>
                        </button>
                      </div>
                    </div>

                    <Splide @splide:active="activeSlideChange" ref="splideRef"
                      :options="{ rewind: true, pagination: false, arrows: false, autoWidth: true, padding: 0, gap: 0 }">
                      <SplideSlide style="border: 0" v-for="(_entry, index) in listings">
                        <div class="w-72 p-4">
                          <div class="bg-white/5 w-full min-h-32 p-2 rounded-md border duration-300"
                            :class="[activeSlide == index ? ' border-white/50' : 'border-transparent']">
                            <div class="w-full flex justify-between items-center text-xs mb-2">
                              <p class=" ">ID: {{ _entry.id }}</p>
                              <p>{{ _entry.action }}</p>
                            </div>

                            <div class="mb-4 w-full">
                              <div class="w-full grid grid-cols-6">
                                <p class="col-span-full text-sm text-turquoise-500">price</p>
                                <p class="col-span-full text-lg text-white">{{ _entry.price }} USDT</p>
                              </div>
                            </div>

                            <template v-if="_entry.action == 'buy' && _entry.item">
                              <section class="w-full grid grid-cols-3 mb-4">
                                <p class="col-span-3 text-woodsmoke-50 text-sm">Allocation</p>
                                <p class="col-span-2 pl-4 text-sm">bought</p>
                                <p class="text-right text-sm">{{ _entry.item.allocation.amount }}</p>

                                <p class="col-span-2 pl-4 text-sm">effective</p>
                                <p class="text-right text-sm">-{{ _entry.item.allocation.effective }}</p>

                                <div class="col-span-full w-full my-1 pl-4 flex">
                                  <div class="w-full h-[0.5px] bg-white/50"></div>
                                </div>

                                <p class="col-span-2 pl-4 text-sm text-turquoise-500">claimable refund</p>
                                <p class="text-right text-sm text-turquoise-500">{{ _entry.item.allocation.refund }}</p>
                              </section>

                              <section class="w-full grid grid-cols-3 mb-4">
                                <p class="col-span-3 text-woodsmoke-50 text-sm">Markup</p>
                                <p class="col-span-2 pl-4 text-sm">initial</p>
                                <p class="text-right text-sm">{{ _entry.item.markup.amount }}</p>

                                <p class="col-span-2 pl-4 text-sm">To Seller</p>
                                <p class="text-right text-sm">-{{ _entry.item.markup.effective }}</p>

                                <div class="col-span-full w-full my-1 pl-4 flex">
                                  <div class="w-full h-[0.5px] bg-white/50"></div>
                                </div>

                                <p class="col-span-2 pl-4 text-sm text-turquoise-500">claimable refund</p>
                                <p class="text-right text-sm text-turquoise-500">{{ _entry.item.markup.refund }}</p>
                              </section>

                              <section class="w-full grid grid-cols-3 mb-4">
                                <p class="col-span-3 text-woodsmoke-50 text-sm">Private Fee (3%)</p>
                                <p class="col-span-2 pl-4 text-sm">collected</p>
                                <p class="text-right text-sm">{{ _entry.item.privateFee.amount }}</p>

                                <p class="col-span-2 pl-4 text-sm">used</p>
                                <p class="text-right text-sm">-{{ _entry.item.privateFee.effective }}</p>

                                <div class="col-span-full w-full my-1 pl-4 flex">
                                  <div class="w-full h-[0.5px] bg-white/50"></div>
                                </div>

                                <p class="col-span-2 pl-4 text-sm text-turquoise-500">claimable refund</p>
                                <p class="text-right text-sm text-turquoise-500">{{ _entry.item.privateFee.refund }}</p>
                              </section>
                            </template>

                            <template v-if="_entry.action == 'sell'">
                              <section class="w-full grid grid-cols-3 mb-4">
                                <p class="col-span-3 text-woodsmoke-50 text-sm">Allocation</p>
                                <p class="col-span-2 pl-4 text-sm">sold to buyer</p>
                                <p class="text-right text-sm">{{ _entry.item.allocation.amount }}</p>

                                <p class="col-span-2 pl-4 text-sm">effective</p>
                                <p class="text-right text-sm">-{{ _entry.item.allocation.effective }}</p>

                                <div class="col-span-full w-full my-1 pl-4 flex">
                                  <div class="w-full h-[0.5px] bg-white/50"></div>
                                </div>

                                <p class="col-span-2 pl-4 text-sm">refund to buyer</p>
                                <p class="text-right text-sm">{{ _entry.item.allocation.refund }}</p>
                              </section>

                              <section class="w-full grid grid-cols-3 mb-4">
                                <p class="col-span-3 text-woodsmoke-50 text-sm">Markup Profit</p>
                                <p class="col-span-2 pl-4 text-sm">initial</p>
                                <p class="text-right text-sm">{{ _entry.item.markup.amount }}</p>

                                <p class="col-span-2 pl-4 text-sm">refund to buyer</p>
                                <p class="text-right text-sm">-{{ _entry.item.markup.refund }}</p>

                                <p class="col-span-2 pl-4 text-sm">OTC Platform Fee</p>
                                <p class="text-right text-sm">-{{ _entry.item.otcFee.effective }}</p>

                                <div class="col-span-full w-full my-1 pl-4 flex">
                                  <div class="w-full h-[0.5px] bg-white/50"></div>
                                </div>

                                <p class="col-span-2 pl-4 text-sm text-turquoise-500">claimable</p>
                                <p class="text-right text-sm text-turquoise-500">{{ _entry.claimable }}</p>
                              </section>

                              <!-- <section class="w-full grid grid-cols-3 mb-4">
                                                <p class="col-span-3 text-woodsmoke-50 text-sm">OTC</p>
                                                <p class="col-span-2 pl-4 text-sm">collected</p>
                                                <p class="text-right text-sm">10</p>
                  
                                                <p class="col-span-2 pl-4 text-sm">refund</p>
                                                <p class="text-right text-sm">-5</p>
                  
                                                <div class="col-span-full w-full my-1 pl-4 flex">
                                                  <div class="w-full h-[0.5px] bg-white/50"></div>
                                                </div>
                  
                                                <p class="col-span-2 pl-4 text-sm text-turquoise-500">claimable</p>
                                                <p class="text-right text-sm text-turquoise-500">5</p>
                                              </section> -->
                            </template>

                            <div class="w-full grid grid-cols-3 justify-center items-end mt-8">
                              <div class="col-span-2">
                                <p class="text-white">Total Claimable</p>
                              </div>

                              <p v-if="_entry.action == 'buy'" class="text-right text-lg text-turquoise-500">{{ _entry.claimable }}</p>
                              <p v-if="_entry.action == 'sell'" class="text-right text-lg text-turquoise-500">{{ _entry.claimable }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </SplideSlide>
                    </Splide>
                  </div>
                </div>
              </HeadlessDialogPanel>
            </HeadlessTransitionChild>
          </div>
        </div>
      </HeadlessDialog>
    </HeadlessTransitionRoot>
  </div>
</template>

<script setup>
const open = ref(false);

import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";

const props = defineProps(["listings", "vesting"]);
const { listings, vesting } = toRefs(props);

const emit = defineEmits(["onClickClaim"])

const splideRef = ref(null);
const activeSlide = ref(0);

const showBreakdown = () => {
  open.value = true;
};

const activeSlideChange = (ev) => {
  // console.log("change",ev);
  activeSlide.value = splideRef.value.splide.index
}

const nextSlide = () => {
  // console.log(splideRef.value.splide.index);
  splideRef.value.splide.go(">");
};

const prevSlide = () => {
  // splideRef.value.splide.go("-");
  splideRef.value.splide.go("<");
};

const splideTo = (index) => {
  splideRef.value.splide.go(index);
};

const claim = (vesting) => {
console.log()
  emit("onClickClaim", vesting)
  open.value = false
}

</script>

<style></style>
